import { format, set } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';

import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 40px auto;

  margin-bottom: ${theme.spaces.regular}px;
  cursor: pointer;

  > * {
    &:nth-child(1) {
      grid-row-start: 1;
      grid-row-end: 3;
    }

    &:nth-child(2) {
      grid-row-start: 1;
      grid-row-end: 2;
    }

    &:nth-child(3) {
      grid-row-start: 2;
      grid-row-end: 3;
    }
  }
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const UpcomingDatesListItem = ({ month, day, description, ...restProps }) => {
  return (
    <StyledContainer {...restProps}>
      <StyledIconContainer>
        <Icon alias={ICON_ALIASES.checkboxFilled} color={theme.colors.indigo.primary} />
      </StyledIconContainer>
      <Text size={theme.fontSizes.small} weight={400} color={theme.colors.gray.secondary}>
        Date:&nbsp;
        {`${format(set(new Date(), { month: month - 1 }), 'MMMM')}, ${day}`}
      </Text>
      <Text size={theme.fontSizes.small} weight={600}>
        {description}
      </Text>
    </StyledContainer>
  );
};

UpcomingDatesListItem.propTypes = {
  month: PropTypes.number,
  day: PropTypes.number,
  description: PropTypes.string,
};

export default UpcomingDatesListItem;
